import { render, staticRenderFns } from "./deactivateModel.vue?vue&type=template&id=24baeb06"
import script from "./deactivateModel.vue?vue&type=script&lang=js"
export * from "./deactivateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24baeb06')) {
      api.createRecord('24baeb06', component.options)
    } else {
      api.reload('24baeb06', component.options)
    }
    module.hot.accept("./deactivateModel.vue?vue&type=template&id=24baeb06", function () {
      api.rerender('24baeb06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organization/companyManage/deactivateModel.vue"
export default component.exports